<template>
  <!-- is-selected 추가시 드롭다운 보임 -->
  <div
    class="dropdown-independent OPTION"
    :class="menu ? 'is-selected' : ''"
  >
    <div class="w--1400px m--auto clearfix">

      <!-- 커뮤니티 -->
      <div class="float--left">
        <div
          class="menu-column"
          v-for="(menu, index) in menus"
          :key="index"
        >
          <ul>
            <!-- <li>
              <a class="menu-md">{{menu.menuName}}</a>
            </li> -->
            <li
              v-for="sub in menu.children"
              :key="sub.menuName"
            ><a
                @click="menuClick(sub)"
                class="menu-md"
              >{{sub.menuName}}</a>
              <ul v-if="sub.children && sub.children.length > 0">
                <li
                  class="menu-sm"
                  v-for="last in sub.children"
                  :key="last.menuName"
                ><a @click="menuClick(last)">{{last.menuName}}</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="header__banner float--right w--380px"
        v-if="menu && menu.route && menu.route.fileName"
      >
        <a
          @click="bannerClick(menu.route)"
          :style="`background-image:url(/api/resources/files/${menu.route.fileName});`"
          class="block bg desktop:ratio--16:9 "
        ></a>
      </div>

      <!-- <div
        v-if="menu"
        class="hospital-nav-container clearfix"
        style="background-image:url(http://remainlab.sshel.com/hospital/MenutabIcon6.png);"
      >

        <div
          class="menu-row clearfix"
          v-for="(chunkMenu, index) in chunkMenus"
          :key="index"
        >
          <div
            class="col-m-4"
            v-for="sub in chunkMenu"
            :key="sub.seq"
          >
            <a
              @click="go(sub)"
              class="menu-md"
            >{{sub.menuName}}</a>
          </div>

        </div> -->
      <!-- 
      <div class="text--center">
        <div class="inline-block px--8px">
          <ul>
            <li><a href="#">menu</a></li>
            <li><a href="#">menu</a></li>
            <li><a href="#">menu</a></li>
            <li><a href="#">menu</a></li>
          </ul>
        </div>
        <div class="inline-block px--8px">
          <ul>
            <li><a href="#">menu</a></li>
          </ul>
        </div>
        <div class="inline-block px--8px">
          <ul>
            <li><a href="#">menu</a></li>
            <li><a href="#">menu</a></li>
            <li><a href="#">menu</a></li>
          </ul>
        </div>
        <div class="inline-block px--8px">
          <ul>
            <li><a href="#">menu</a></li>
          </ul>
        </div>
      </div>
       -->

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    menus: { type: Array },
    menu: { type: Object },
    menuClick: { type: Function }
  },
  computed: {
    ...mapState(['company'])
  },
  methods: {
    bannerClick (route) {
      if (route.newWindowFlag === 'Y') {
        window.open(route.link, '_blank')
      } else {
        location.href = route.link
      }
    }
  }
}
</script>
